import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { yieldToMainBackground } from "../common/utils";
import { MpVideoPlayer } from "../common/video_player";

function removeGridPlayer() {
	const video_container = document.querySelector("#_video_container");

	// remove current player
	const current_player = jwplayer("_video_player");
	if (Object.prototype.hasOwnProperty.call(current_player, "remove")) {
		current_player.remove();
	}
	for (const el of document.querySelectorAll(".selectedItem")) {
		el.classList.remove("selectedItem");
	}
	document.querySelector(".gridder").classList.remove("hasSelectedItem");
	video_container.classList.add("d-none");
}

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	endlessPaginate({
		moreSelector: "span.endless_more",
		moreSelectorDataUrl: "data-more",
	});

	const multiJWP = new MpVideoPlayer();
	multiJWP.init().then((is_ready) => {
		document
			.querySelector(".gridder-close")
			.addEventListener("click", (event) => {
				event.preventDefault();
				removeGridPlayer();
			});

		document.querySelector(".gridder").addEventListener("click", (event) => {
			event.preventDefault();
			const target = event.target;

			if (target.classList.contains("gridder-link")) {
				const video = target.closest(".gridder-list");
				const video_container = document.querySelector("#_video_container");

				if (video.classList.contains("selectedItem")) {
					removeGridPlayer();
				} else {
					// load new player
					if (is_ready) {
						yieldToMainBackground().then(() => {
							const new_player = multiJWP.setupPlayer(
								"_video_player",
								video.dataset.video_uid,
								{
									noads: video.dataset.no_ads,
									article_url: video.dataset.video_article,
									is_downloadable: true,
								},
							);
							video.classList.add("selectedItem");
							document
								.querySelector(".gridder")
								.classList.add("hasSelectedItem");
							video.insertAdjacentElement("afterend", video_container);
							video_container.classList.remove("d-none");
							new_player.play();
						});
					}
				}
			}
		});
	});
});
